export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["स्वागत बोनस"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अपनी किस्मत आज़माएं!"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["आप जीत गए"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पहिया घुमाएं और सभी प्लेटफॉर्म सुविधाओं का अन्वेषण करने के लिए टेस्ट फंड प्राप्त करें।"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ये फंड टेस्टिंग के लिए हैं।"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["डुबकी लगाएं और सभी सुविधाओं का अनुभव करें।"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["घुमाएं"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["दावा करें"])}
}